import { render } from "./BtnIconGroup.vue?vue&type=template&id=fce27300"
import script from "./BtnIconGroup.vue?vue&type=script&lang=js"
export * from "./BtnIconGroup.vue?vue&type=script&lang=js"

import "./BtnIconGroup.vue?vue&type=style&index=0&id=fce27300&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__